import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import "./styles.css";  // Optional for custom styles
import { BrowserRouter } from "react-router-dom";
import "./index.css"; 

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </React.StrictMode>
);